export default __webpack_public_path__ + "static/media/domestic.dcbb527c.svg";